import { useUserContext } from '../../../contexts/UserContext';
import { RoleName } from '../../../enums/RoleNameEnm';
import { useNavigate } from 'react-router-dom';
import { indexedDBManager } from '../../../utils/indexedDB';

export const useSetUserAndToken = () => {
  const { setUserInfo, setUserToken } = useUserContext();
  const navigate = useNavigate();

  const setUserAndToken = async (user: any, token: string, allowPermission: any, deviceToken: string) => {
    const { email, passwordExpiredAt, roleName, firstName, fullName, userId } = user;
    await indexedDBManager.resetForSessionOwner(userId);
    setUserToken(token);
    setUserInfo({
      email: email,
      passwordExpiredAt: passwordExpiredAt,
      deviceToken: deviceToken,
      roleName: roleName as RoleName | undefined,
      permissions: allowPermission,
      name: firstName ?? fullName?.split(' ')[0] ?? '',
      userId: userId,
    });

    // redirect user to different page based on role
    switch (roleName) {
      case RoleName.ADMIN:
        navigate('/administration', { replace: true });
        break;
      case RoleName.SYSTEM_ADMIN:
        navigate('/administration', { replace: true });
        break;
      case RoleName.ANALYST:
        navigate('/analysis', { replace: true });
        break;
      case RoleName.AUDITOR:
        navigate('/inspector', { replace: true });
        break;
      case RoleName.INSPECTOR:
        navigate('/inspector', { replace: true });
        break;
      case RoleName.CITIZEN:
        navigate('/citizenPortal', { replace: true });
        break;
      default:
        navigate('/', { replace: true });
    }
  };

  return { setUserAndToken };
};
